import React from 'react';

import BillDetailsEditContainer from '../../../../bills/components/edit/BillDetailsEditContainer';

export default function BillDetailsEditScreen() {
    return <BillDetailsEditContainer />;
}
